import React, { Component } from 'react';
import { observer } from 'mobx-react';

import FeedbackMenuItemsStore from 'stores/Feedback/FeedbackMenuItemsStore';
import { ModalProps } from 'stores/ModalStore';

import TagsSelectModal, {
  IGroupTag,
} from 'components/Modals/TagsSelectModal/TagsSelectModal';

@observer
class FeedbackMenuItemsModal extends Component<ModalProps> {
  private _store = new FeedbackMenuItemsStore();

  componentDidMount() {
    this._store.init();
  }

  render() {
    return (
      <TagsSelectModal
        {...this.props}
        title="modal.feedback.menuItems.title"
        description="modal.feedback.menuItems.description"
        withGroups
        tags={this._store.tags}
        selectedTags={this._store.defaultSelectedTags}
        isShowTags={false}
        isShowSearchField
        loading={this._store.loading}
        onSubmit={this._handleSubmit}
      />
    );
  }

  private _handleSubmit = async (data: IGroupTag[]) => {
    await this._store.submit(data);
    this.props.onClose();
  };
}

export default FeedbackMenuItemsModal;
